import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../helpers/api/Api";
import { showStatus } from "../../helpers/api/errors/ShowStatus";

function DeleteDialog({ item, itemId, itemName, deleteUrl, handleCloseModal, disabled }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onDelete = () => {
    setLoading(true);
    const snackArgs = {
      item: itemName,
      op: t("global.delete")
    };

    const formData = new FormData();
    formData.append("uid", item.id);

    api.post(deleteUrl, formData)
      .then((response) => {
        setLoading(false);
        setOpen(false);
        showStatus(response.data.status, snackArgs);
        if (response.data.status === "success") {
          handleCloseModal();
        }
      })
      .catch((error) => {
        setLoading(false);
        setOpen(false);
        showStatus("error", snackArgs);
      });
  }

  return (
    <>
      <IconButton color="error" onClick={handleOpen} disabled={disabled}>
        <DeleteIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("message.confirm", {
              item: itemName,
              id: itemId ? item[itemId] : "",
              op: t("global.delete")
            })}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="error" variant="contained">
            {t("global.cancel")}
          </Button>

          <LoadingButton
            color="success"
            loading={loading}
            variant="contained"
            onClick={onDelete}
          >
            {t("global.confirm")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteDialog;
